let _initProto, _initClass, _init_label, _init_extra_label, _init_ariaBusy, _init_extra_ariaBusy, _init_selectionMode, _init_extra_selectionMode, _init_value, _init_extra_value, _init_sortColumn, _init_extra_sortColumn, _init_sortDirection, _init_extra_sortDirection, _init_changeEvent, _init_extra_changeEvent, _init_sortChangeEvent, _init_extra_sortChangeEvent, _init_rowActionEvent, _init_extra_rowActionEvent;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, customElement, event, onEvent, onUpdated, prop } from "@ecopages/radiant";
import { applyRovingTabindex } from "@/lib/roving-tabindex";
import { parseMultiValue, serializeMultiValue } from "../shared/multi-value";
let _RuiTable;
class RuiTable extends RadiantElement {
  static {
    ({
      e: [_init_label, _init_extra_label, _init_ariaBusy, _init_extra_ariaBusy, _init_selectionMode, _init_extra_selectionMode, _init_value, _init_extra_value, _init_sortColumn, _init_extra_sortColumn, _init_sortDirection, _init_extra_sortDirection, _init_changeEvent, _init_extra_changeEvent, _init_sortChangeEvent, _init_extra_sortChangeEvent, _init_rowActionEvent, _init_extra_rowActionEvent, _initProto],
      c: [_RuiTable, _initClass]
    } = _applyDecs(this, [customElement("rui-table")], [[prop({
      type: String,
      defaultValue: ""
    }), 0, "label"], [prop({
      type: String,
      attribute: "aria-busy",
      defaultValue: "false"
    }), 0, "ariaBusy"], [prop({
      type: String,
      attribute: "selection-mode",
      defaultValue: "none"
    }), 0, "selectionMode"], [prop({
      type: String,
      reflect: true,
      defaultValue: ""
    }), 0, "value"], [prop({
      type: String,
      attribute: "sort-column",
      reflect: true,
      defaultValue: ""
    }), 0, "sortColumn"], [prop({
      type: String,
      attribute: "sort-direction",
      reflect: true,
      defaultValue: "ascending"
    }), 0, "sortDirection"], [event({
      name: "rui-change",
      bubbles: true,
      composed: true
    }), 0, "changeEvent"], [event({
      name: "rui-sort-change",
      bubbles: true,
      composed: true
    }), 0, "sortChangeEvent"], [event({
      name: "rui-row-action",
      bubbles: true,
      composed: true
    }), 0, "rowActionEvent"], [onUpdated(["value", "selectionMode"]), 2, "onSelectionUpdated"], [onUpdated(["sortColumn", "sortDirection"]), 2, "onSortUpdated"], [onEvent({
      selector: "[data-table-cell]",
      type: "click"
    }), 2, "onCellClick"], [onEvent({
      selector: "[data-table-cell]",
      type: "dblclick"
    }), 2, "onCellDoubleClick"], [onEvent({
      selector: "[data-table-cell]",
      type: "keydown"
    }), 2, "onCellKeydown"], [onEvent({
      selector: "rui-checkbox[data-table-select-row]",
      type: "rui-change"
    }), 2, "onRowSelectionChange"], [onEvent({
      selector: "rui-checkbox[data-table-select-all]",
      type: "rui-change"
    }), 2, "onSelectAllChange"], [onEvent({
      selector: "[data-table-sort]",
      type: "click"
    }), 2, "onSortClick"]], 0, void 0, RadiantElement));
  }
  label = (_initProto(this), _init_label(this));
  ariaBusy = (_init_extra_label(this), _init_ariaBusy(this));
  selectionMode = (_init_extra_ariaBusy(this), _init_selectionMode(this));
  value = (_init_extra_selectionMode(this), _init_value(this));
  sortColumn = (_init_extra_value(this), _init_sortColumn(this));
  sortDirection = (_init_extra_sortColumn(this), _init_sortDirection(this));
  changeEvent = (_init_extra_sortDirection(this), _init_changeEvent(this));
  sortChangeEvent = (_init_extra_changeEvent(this), _init_sortChangeEvent(this));
  rowActionEvent = (_init_extra_sortChangeEvent(this), _init_rowActionEvent(this));
  structureObserver = void _init_extra_rowActionEvent(this);
  rovingSyncPending = false;
  connectedCallback() {
    super.connectedCallback();
    this.observeStructure();
  }
  onConnected() {
    this.syncSelectionState();
    this.syncSorting();
    this.syncRovingTabindex();
  }
  disconnectedCallback() {
    this.structureObserver?.disconnect();
    this.structureObserver = void 0;
    super.disconnectedCallback();
  }
  onSelectionUpdated() {
    this.syncSelectionState();
  }
  onSortUpdated() {
    this.syncSorting();
  }
  observeStructure() {
    if (typeof MutationObserver === "undefined") {
      return;
    }
    this.structureObserver?.disconnect();
    this.structureObserver = new MutationObserver(() => this.queueRovingSync());
    this.structureObserver.observe(this, {
      childList: true,
      subtree: true
    });
  }
  queueRovingSync() {
    if (this.rovingSyncPending) {
      return;
    }
    this.rovingSyncPending = true;
    queueMicrotask(() => {
      this.rovingSyncPending = false;
      if (!this.isConnected) {
        return;
      }
      this.syncRovingTabindex();
    });
  }
  getRows() {
    return Array.from(this.querySelectorAll("[data-table-row]"));
  }
  getSelectableRows() {
    return this.getRows().filter(row => !row.hidden && row.getAttribute("aria-disabled") !== "true");
  }
  getRowCells(row) {
    return Array.from(row.children).filter(child => child instanceof HTMLElement && child.hasAttribute("data-table-cell"));
  }
  getFocusableCells() {
    return this.getSelectableRows().flatMap(row => this.getRowCells(row));
  }
  selectedIds() {
    return this.selectionMode === "multiple" ? parseMultiValue(this.value) : this.value ? [this.value] : [];
  }
  setSelectedIds(ids) {
    this.value = this.selectionMode === "multiple" ? serializeMultiValue(ids) : ids[0] ?? "";
    this.syncSelectionState();
    this.changeEvent.emit({
      value: this.value
    });
  }
  getActiveCellPosition() {
    const cells = this.getFocusableCells();
    const activeIndex = cells.findIndex(cell => cell.tabIndex === 0);
    const activeCell = activeIndex >= 0 ? cells[activeIndex] : this.querySelector("[data-table-cell]:focus") ?? null;
    if (!activeCell) {
      return null;
    }
    const row = activeCell.closest("[data-table-row]");
    if (!row) {
      return null;
    }
    const columnIndex = this.getRowCells(row).indexOf(activeCell);
    if (columnIndex < 0) {
      return null;
    }
    return {
      rowId: row.getAttribute("data-table-row") ?? "",
      columnIndex
    };
  }
  syncSelectionState() {
    const selected = new Set(this.selectedIds());
    const selectableRows = this.getSelectableRows();
    const canSelect = this.selectionMode !== "none";
    for (const row of this.getRows()) {
      const rowId = row.getAttribute("data-table-row") ?? "";
      if (canSelect) {
        row.setAttribute("aria-selected", String(selected.has(rowId)));
      } else {
        row.removeAttribute("aria-selected");
      }
      const rowCheckbox = row.querySelector("rui-checkbox[data-table-select-row]");
      if (rowCheckbox) {
        rowCheckbox.checked = canSelect && selected.has(rowId);
        rowCheckbox.disabled = !canSelect || row.getAttribute("aria-disabled") === "true";
      }
    }
    for (const selectAll of this.querySelectorAll("rui-checkbox[data-table-select-all]")) {
      const selectedCount = selectableRows.filter(row => selected.has(row.getAttribute("data-table-row") ?? "")).length;
      const canSelectAll = this.selectionMode === "multiple";
      selectAll.checked = canSelectAll && selectableRows.length > 0 && selectedCount === selectableRows.length;
      selectAll.indeterminate = canSelectAll && selectedCount > 0 && selectedCount < selectableRows.length;
      selectAll.disabled = !canSelectAll || selectableRows.length === 0;
    }
  }
  syncRovingTabindex() {
    const cells = this.getFocusableCells();
    if (cells.length === 0) {
      return;
    }
    const position = this.getActiveCellPosition();
    let activeIndex = cells.findIndex(cell => cell.tabIndex === 0);
    if (position) {
      const row = this.getRows().find(candidate => candidate.getAttribute("data-table-row") === position.rowId);
      if (row) {
        const target = this.getRowCells(row)[position.columnIndex];
        const index = target ? cells.indexOf(target) : -1;
        if (index >= 0) {
          activeIndex = index;
        }
      }
    }
    applyRovingTabindex(cells, activeIndex >= 0 ? activeIndex : 0);
  }
  syncSorting() {
    for (const column of this.querySelectorAll("[data-table-column]")) {
      const id = column.getAttribute("data-table-column");
      if (id && id === this.sortColumn) {
        column.setAttribute("aria-sort", this.sortDirection);
      } else {
        column.removeAttribute("aria-sort");
      }
    }
  }
  isInteractiveTarget(target) {
    return Boolean(target.closest('button, input, select, textarea, a[href], [contenteditable="true"]'));
  }
  selectRow(row, toggle = false) {
    if (this.selectionMode === "none" || row.getAttribute("aria-disabled") === "true") {
      return;
    }
    const rowId = row.getAttribute("data-table-row") ?? "";
    if (!rowId) {
      return;
    }
    if (this.selectionMode === "single") {
      this.setSelectedIds([rowId]);
      return;
    }
    const selected = new Set(this.selectedIds());
    if (toggle && selected.has(rowId)) {
      selected.delete(rowId);
    } else {
      selected.add(rowId);
    }
    this.setSelectedIds([...selected]);
  }
  focusCell(row, columnIndex) {
    const cells = this.getFocusableCells();
    const rowCells = this.getRowCells(row);
    const target = rowCells[Math.min(Math.max(columnIndex, 0), rowCells.length - 1)];
    const index = cells.indexOf(target);
    if (index < 0) {
      return;
    }
    applyRovingTabindex(cells, index);
    target.focus();
    target.scrollIntoView({
      block: "nearest",
      inline: "nearest"
    });
  }
  activateRow(row) {
    if (!row.hasAttribute("data-table-actionable") || row.getAttribute("aria-disabled") === "true") {
      return;
    }
    const rowId = row.getAttribute("data-table-row") ?? "";
    if (rowId) {
      this.rowActionEvent.emit({
        rowId
      });
    }
  }
  onCellClick(event2) {
    const target = event2.target;
    if (this.isInteractiveTarget(target)) {
      return;
    }
    const cell = target.closest("[data-table-cell]");
    const row = cell?.closest("[data-table-row]");
    if (!cell || !row || !this.contains(row)) {
      return;
    }
    this.selectRow(row, this.selectionMode === "multiple");
    this.focusCell(row, this.getRowCells(row).indexOf(cell));
  }
  onCellDoubleClick(event2) {
    const target = event2.target;
    if (this.isInteractiveTarget(target)) {
      return;
    }
    const row = target.closest("[data-table-row]");
    if (row && this.contains(row)) {
      this.activateRow(row);
    }
  }
  onCellKeydown(event2) {
    const target = event2.target;
    if (this.isInteractiveTarget(target)) {
      return;
    }
    const cell = target.closest("[data-table-cell]");
    const row = cell?.closest("[data-table-row]");
    if (!cell || !row) {
      return;
    }
    const rows = this.getSelectableRows();
    const rowIndex = rows.indexOf(row);
    const rowCells = this.getRowCells(row);
    const columnIndex = rowCells.indexOf(cell);
    switch (event2.key) {
      case "ArrowRight":
        event2.preventDefault();
        this.focusCell(row, columnIndex + 1);
        return;
      case "ArrowLeft":
        event2.preventDefault();
        this.focusCell(row, columnIndex - 1);
        return;
      case "ArrowDown":
        event2.preventDefault();
        this.focusCell(rows[Math.min(rowIndex + 1, rows.length - 1)] ?? row, columnIndex);
        return;
      case "ArrowUp":
        event2.preventDefault();
        this.focusCell(rows[Math.max(rowIndex - 1, 0)] ?? row, columnIndex);
        return;
      case "Home":
        event2.preventDefault();
        this.focusCell(row, 0);
        return;
      case "End":
        event2.preventDefault();
        this.focusCell(row, rowCells.length - 1);
        return;
      case " ":
        event2.preventDefault();
        this.selectRow(row, true);
        return;
      case "Enter":
        event2.preventDefault();
        this.activateRow(row);
        return;
      default:
        return;
    }
  }
  onRowSelectionChange(event2) {
    const checkbox = event2.target;
    const row = checkbox.closest("[data-table-row]");
    if (!row || !this.contains(row)) {
      return;
    }
    const rowId = row.getAttribute("data-table-row") ?? "";
    if (!event2.detail.checked) {
      const selected = new Set(this.selectedIds());
      selected.delete(rowId);
      this.setSelectedIds([...selected]);
      return;
    }
    this.selectRow(row);
  }
  onSelectAllChange(event2) {
    if (this.selectionMode !== "multiple") {
      return;
    }
    this.setSelectedIds(event2.detail.checked ? this.getSelectableRows().map(row => row.getAttribute("data-table-row") ?? "") : []);
  }
  onSortClick(event2) {
    const button = event2.target.closest("[data-table-sort]");
    const column = button?.getAttribute("data-table-sort");
    if (!column) {
      return;
    }
    this.sortDirection = column === this.sortColumn && this.sortDirection === "ascending" ? "descending" : "ascending";
    this.sortColumn = column;
    this.syncSorting();
    this.sortChangeEvent.emit({
      column,
      direction: this.sortDirection
    });
  }
  static {
    _initClass();
  }
}
export { _RuiTable as RuiTable };